<template>
  <div>
    <v-client-table class="fixed_header" ref="tableListe"
                    :data="panneauxWithFilter"
                    :columns="columns"
                    :options="options">
      <div slot="Disponibilite" slot-scope="props"
           class="image is-24x24 button noHandCursor centrer_disponibilite"
           v-bind:class="props.row.dispoClass">
      </div>
      <div slot="selected" slot-scope="props">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.selected"
        @click="ajouterAuPanier(props.row)">
      </div>
      <div slot="pdf" slot-scope="props">
        <b-button
          class="has-background-transparent no_border pa-0"
          @click="download(props.row)">
          <b-icon icon="file-pdf" type="is-danger"/>
        </b-button>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { TEXTS, RESULTS_PER_PAGE, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import { getFichePdf } from '@/api/panneauxNumeriques';

const Numerique = createNamespacedHelpers('venteNumerique');

export default {
  name: 'liste',
  data() {
    return {
      trad: {
        selected: '',
        code: '↑↓ Code Panneau',
        Format: '↑↓ Format',
        Materiel: '↑↓ Matériel',
        adresse: '↑↓ Adresse',
        CodePostal: '↑↓ Code Postal',
        Ville: '↑↓ Ville',
        Departement: '↑↓ Département',
        Disponibilite: 'Dispo',
        nbPropositions: '↑↓ Propals',
        restrictions: '↑↓ Restrictions',
        pdf: 'PDF',
      },
      produitSelect: {},
    };
  },
  watch: {
    filterChanged() {
      // Lorsque les filtres changent on force la passage à la page 1
      // pour éviter d'avoir une liste vide
      this.$refs.tableListe.setPage(1);
    },
    panneauxWithFilter(val) {
      this.$emit('liste', {
        data: val,
        type: 'faceNum',
      });
    },
  },
  computed: {
    ...Numerique.mapGetters({
      filterChanged: 'filterChanged',
      criterePlanning: 'criterePlanning',
      panneauxWithFilter: 'panneauxWithFilter',
      getTypeVente: 'typeVente',
    }),
    typeVente: {
      get() {
        return this.getTypeVente;
      },
      set(value) {
        this.setTypeVente(value);
      },
    },
    columns() {
      return ['selected', 'Disponibilite', 'code', 'pdf', 'format', 'materiel', 'adresseCommercialeLibelle1', 'codePostal', 'ville', 'departement', 'restrictions'];
    },
    options() {
      return {
        headings: {
          selected: this.trad.selected,
          code: this.trad.code,
          facCode: this.trad.facCode,
          format: this.trad.Format,
          materiel: this.trad.Materiel,
          adresseCommercialeLibelle1: this.trad.adresse,
          codePostal: this.trad.CodePostal,
          ville: this.trad.Ville,
          departement: this.trad.Departement,
          Disponibilite: this.trad.Disponibilite,
          restrictions: this.trad.restrictions,
          pdf: this.trad.pdf,
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          adresseCommercialeLibelle1: 'ellipsis ventesReseauxListeTailleColonneAdresse',
          ville: 'ellipsis ventesReseauxListeTailleColonneVille',
          selected: 'colonneBoutonFaceLcListe has-text-centered',
          Disponibilite: 'colonneBoutonFaceLcListe has-text-centered',
          pdf: 'colonneBoutonFaceLcListe has-text-centered',
        },
      };
    },
  },
  methods: {
    ...Numerique.mapMutations({
      setPanneauxWithFilter: types.SET_PANNEAUX_WITH_FILTER,
      setPanneauSelected: types.SET_PANNEAU_SELECTED,
      setTypeVente: types.SET_TYPE_VENTE,
    }),
    ...Numerique.mapActions({
      actionsSelectionneFacesPanneaux: 'selectionneFacesPanneaux',
      actionsGestionPanier: 'gestionPanier',
    }),
    ajouterAuPanier(face) {
      const tarification = 100 + 1;
      this.typeVente = 100;
      this.setPanneauSelected({
        panNum: face.num,
        value: true,
      });
      this.actionsGestionPanier({
        panNum: face.num,
        periode: 'du ' + this.criterePlanning.dateStart.format('DD/MM/YYYY') + ' au ' + this.criterePlanning.dateEnd.format('DD/MM/YYYY'),
        tarification: tarification,
      });
    },
    async download(data) {
      this.produitSelect = cloneDeep(data);
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const resp = await getFichePdf(this.produitSelect);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(resp.data);
        const disposition = resp.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        gestionErreur(`Erreur lors de l'impression de la fiche de l'écran numérique n°${this.produitSelect.code}`, e);
      }
      loadingComponent.close();
    },
  },
  mounted() {
    this.$emit('liste', {
      data: this.panneauxWithFilter,
      type: 'faceNum',
    });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/liste.vue